/** Blue accent shared by selection, shape-text editing, alt-hover and the text-on-path start dot. */
export const SELECTION_HIGHLIGHT_COLOR = 'var(--editor-bounding-box-accent, #0284C7)'

/** Cyan outline for a frozen (geometry-blocked) object. */
export const FROZEN_SELECTION_HIGHLIGHT_COLOR = 'var(--color-page-editor-freeze, #0891B2)'

export const SELECTION_HIGHLIGHT_STROKE_WIDTH = 1
